import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, FrontAppIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof FrontAppIntegrationResponseDataSchema>>

export const frontAppIntegrationQueryKey = ["frontAppIntegration"]

type Props = {
  onSuccess?: (data: Response) => void
}

export const frontAppIntegrationQuery = ({ onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: frontAppIntegrationQueryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/frontapp`)

      onSuccess?.(response.data)

      return response.data.data ?? null
    },
  })
}
